


import { Component, Vue } from "vue-property-decorator";

import { CustomNotification } from "@Internal/Models";
import { ValidateEmail } from "@Internal/Utils";
import { CustomError } from "@Internal/Models";

import { ConsoleUsers } from "App";
import { Role, User } from "App/Models";
import { $t, EventBus } from "App/IOC";

import { Activated, Identifiable, Named } from "App/Contracts";
import { Option } from "Web/Contracts";

import PopupWindow from "Web/Components/Popup/Window.vue";
import SimpleSelect from "Web/Components/V2/Select/Simple.vue";

@Component({
    components: {
        PopupWindow,
        SimpleSelect
    }
})
export default class InviteForm extends Vue {
    private model = {
        FirstName: "",
        LastName: "",
        Email: "",
        Phone: ""
    };

    private roles: Role[] = [];

    /* Must be initialised (not just declared) so Vue observes it — a bare `selectedRole?: Role;`
       emits no own property and renders trigger "property not defined on the instance". */
    private selectedRole: Role | undefined = undefined;

    private inviteAction: Identifiable & Named & Activated = {
        Id: "invite",
        Name: $t( "CONSOLE_USERS_confirmInvite" ),
        Active: false
    };

    private get roleOptions(): Option[] {
        return this.roles as unknown as Option[];
    }

    private get canInvite(): boolean {
        return this.model.FirstName.trim() !== "" &&
            this.model.LastName.trim() !== "" &&
            !( ValidateEmail( this.model.Email ) instanceof CustomError );
    }

    private async created(): Promise<void> {
        const [ roles, error ] = await ConsoleUsers.GetRoles();

        if( error !== undefined ) {
            EventBus.Publish( "Error", error );
            return;
        }

        this.roles = roles;
    }

    private selectRole( role: Role ): void {
        this.selectedRole = role;
        this.refreshAction();
    }

    private refreshAction(): void {
        this.inviteAction.Active = this.canInvite;
    }

    private async invite(): Promise<void> {
        if( !this.canInvite )
            return;

        this.inviteAction.Active = false;

        const user = User.New();

        user.FirstName = this.model.FirstName;
        user.LastName = this.model.LastName;
        user.Email = this.model.Email;
        user.Phone = this.model.Phone;

        if( this.selectedRole !== undefined )
            user.RoleId = this.selectedRole.Id;

        const error = await ConsoleUsers.Invite( user );

        if( error !== undefined ) {
            EventBus.Publish( "Error", error );
            this.refreshAction();
            return;
        }

        EventBus.Publish( "Notification", CustomNotification.Success(
            $t( "CONSOLE_USERS_inviteSuccessTitle" ),
            $t( "CONSOLE_USERS_inviteSuccessMessage" )
        ));

        this.$emit( "Create" );
        this.$emit( "Close" );
    }
}
